import { useNavigate } from 'react-router-dom';
import '../styles/BundleCard.css';

const BundleCard = ({ bundle, isSelected }) => {
  const navigate = useNavigate();

  return (
    <div 
      className={`bundle-card ${isSelected ? 'selected' : ''}`}
      onClick={() => navigate(`/bundle/${bundle.id}`)}
    >
      <img src={bundle.image} alt={bundle.name} />
      <h3>{bundle.name}</h3>
      <p>{bundle.description}</p>
      <p className="price">${bundle.price.toFixed(2)}</p>
      {isSelected && <span className="selected-badge">Selected</span>}
    </div>
  );
};

export default BundleCard;